var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"segment-row"},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.type))])]),_c('div',[_c('p',[_vm._v("Bit length: "+_vm._s(_vm.bitLength))])])])}
var staticRenderFns = []

export { render, staticRenderFns }